(() => {
  if (customElements.get('thaki-shopping-helper')) return;
  customElements.define('thaki-shopping-helper', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = document.getElementById('ThakasaProductForm') || document.querySelector('main product-info form[action*="/cart/add"]');
      if (!this.form) return;
      this.initialized = true;
      this.form.after(this);
      this.add = this.querySelector('.thaki-shop__add');
      this.message = this.querySelector('.thaki-shop__message');
      this.cart = this.querySelector('.thaki-shop__cart');
      this.panel = this.querySelector('.thaki-shop__panel');
      this.reopen = this.querySelector('.thaki-shop__reopen');
      this.sync = () => {
        const input = this.form.querySelector('[name="id"]');
        const submit = this.form.querySelector('[type="submit"]');
        const option = input?.selectedOptions?.[0];
        this.available = Boolean(input?.value && !input.disabled && !option?.disabled && submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true');
        this.add.disabled = this.busy || !this.available;
        if (!this.busy) this.add.textContent = this.available ? this.dataset.add : this.dataset.unavailable;
      };
      this.reset = () => { if (!this.busy) { this.message.textContent = this.dataset.prompt; this.cart.hidden = true; this.add.hidden = false; } this.sync(); };
      this.form.addEventListener('change', this.reset);
      this.form.addEventListener('input', this.reset);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form, {subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled','value'], childList:true});
      this.querySelector('.thaki-shop__close').addEventListener('click', () => { this.panel.hidden = true; this.reopen.hidden = false; this.reopen.focus(); try { sessionStorage.setItem('thaki-helper-dismissed','1'); } catch {} });
      this.reopen.addEventListener('click', () => { this.panel.hidden = false; this.reopen.hidden = true; this.querySelector('.thaki-shop__close').focus(); try { sessionStorage.removeItem('thaki-helper-dismissed'); } catch {} });
      try { if (sessionStorage.getItem('thaki-helper-dismissed')) { this.panel.hidden = true; this.reopen.hidden = false; } } catch {}
      this.add.addEventListener('click', () => this.addProduct());
      this.sync();
      this.hidden = false;
    }
    async addProduct() {
      this.sync();
      if (this.busy || !this.available || !this.form.reportValidity()) return;
      this.busy = true;
      this.add.disabled = true;
      this.add.textContent = this.dataset.adding;
      const data = new FormData(this.form);
      data.set('sections','cart-icon-bubble,cart-drawer');
      data.set('sections_url',location.pathname);
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{Accept:'application/json'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        this.message.textContent = this.dataset.success;
        this.add.hidden = true;
        this.cart.hidden = false;
        this.cart.focus({preventScroll:true});
        for (const id of ['cart-icon-bubble','cart-drawer']) {
          const html = result.sections?.[id];
          if (!html) continue;
          const parsed = new DOMParser().parseFromString(html,'text/html');
          const selector = id === 'cart-drawer' ? '#CartDrawer' : '#cart-icon-bubble';
          const target = document.querySelector(selector);
          const replacement = parsed.querySelector(selector);
          if (target && replacement) target.innerHTML = replacement.innerHTML;
        }
        document.querySelector('cart-drawer')?.classList.remove('is-empty');
      } catch (error) {
        this.message.textContent = error.message || this.dataset.error;
      } finally {
        this.busy = false;
        this.sync();
      }
    }
  });
})();
